export default __webpack_public_path__ + "static/media/home-img-3.7ee33bd8.png";